// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__Gmizu","selects":"Documents_selects__2VNd6"};